<template>
  <div class="auth-wrapper auth-v1 px-2">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    >
    </loading>
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img fluid :src="sideImg" />
        </b-link>

        <b-card-title class="mb-1"> ลงทะเบียน </b-card-title>
        <b-card-text class="mb-2">
          เพื่อเข้าร่วมเป็นส่วนหนึ่งของพร้อมสั่ง และขายสินค้าต่างๆ
          จากร้านของคุณได้เลย
        </b-card-text>

        <!-- form -->
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- <b-form-group
              label="ชื่อ"
              label-for="firstName"
            >
              <validation-provider
                #default="{ errors }"
                name="First Name"
                rules="required"
              >
                <b-form-input
                  id="firstName"
                  v-model="firstName"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="นามสกุล"
              label-for="lastName"
            >
              <validation-provider
                #default="{ errors }"
                name="Last Name"
                rules="required"
              >
                <b-form-input
                  id="lastName"
                  v-model="lastName"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group> -->

            <b-form-group label="ชื่อ - นามสกุล" label-for="fullName">
              <validation-provider
                #default="{ errors }"
                name="Name - Surname"
                rules="required"
              >
                <b-form-input
                  id="fullName"
                  v-model="fullName"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="เบอร์โทรศัพท์" label-for="phone">
              <validation-provider
                #default="{ errors }"
                name="Phone"
                rules="required"
              >
                <b-form-input
                  id="phone"
                  v-model="phone"
                  readonly
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- <b-form-group label="เลขบัตรประชาชน" label-for="citizenId">
              <validation-provider
                #default="{ errors }"
                name="CitizenId"
                rules="required"
              >
                <b-form-input
                  id="citizenId"
                  v-model="citizenId"
                  readonly
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group> -->

            <b-form-group label="อีเมล" label-for="email">
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="รหัสผ่าน" label-for="password">
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIcon"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="ยืนยันรหัสผ่าน" label-for="password">
              <validation-provider
                #default="{ errors }"
                name="confirmPassword"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="confirmpassword"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIcon"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Terms and Privacy Policy"
                rules="required"
              >
                <b-form-checkbox
                  id="isAccept"
                  v-model="isAccept"
                  :state="errors.length > 0 ? false : null"
                >
                  ฉันยอมรับ
                  <b-link>ข้อกำหนดและนโยบายความเป็นส่วนตัว</b-link>
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <div v-if="isError" style="color: red">
              {{ isErrorMessage }}
            </div>

            <b-button variant="primary" block type="submit">
              ลงทะเบียน
            </b-button>
          </b-form>
        </validation-observer>

        <!-- <b-card-text class="text-center mt-2">
          <span>มีบัญชีผู้ใช้งานแล้ว ? </span>
          <b-link :to="{name:'auth-login'}">
            <span>เข้าสู่ระบบ</span>
          </b-link>
        </b-card-text> -->
      </b-card>

      <b-modal
        id="modal-no-backdrop"
        ref="my-modal"
        title="ข้อกำหนดและนโยบายความเป็นส่วนตัว"
        centered
        hide-backdrop
        hide-header-close
        no-close-on-backdrop
        content-class="shadow"
        ok-title="ยอมรับ"
        cancel-title="ไม่ยอมรับ"
        cancel-variant="outline-secondary"
        @ok="handleOk"
        size="xl"
      >
        <div v-html="privacyData"></div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BImg,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BModal,
  VBModal,
  BRow,
  BCol,
} from "bootstrap-vue";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { onUnmounted } from "@vue/composition-api";
import useJwt from "@/auth/jwt/useJwt";
// eslint-disable-next-line import/no-cycle
import router from "@/router";
import store from "@/store/index";
import authenStoreModule from "./authenStoreModule";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BImg,
    BModal,
    BRow,
    BCol,
    // validations
    ValidationProvider,
    ValidationObserver,
    Loading,
  },
  directives: {
    "b-modal": VBModal,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: require("@/assets/images/logo/logo.png"),
      // firstName: '',
      // lastName: '',
      fullName: "",
      phone: router.currentRoute.params.phone,
      email: "",
      username: "",
      password: "",
      confirmpassword: "",
      isAccept: false,
      citizenId: "",
      // validation rules
      required,
      isError: false,
      isErrorMessage: "",
      privacyData: "",
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  setup() {
    // Register module
    if (!store.hasModule("authen"))
      store.registerModule("authen", authenStoreModule);

    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule('authen')) store.unregisterModule('authen')
    // })

    return {};
  },
  mounted() {
    this.getPrivacy();
  },
  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },
    getPrivacy() {
      store
        .dispatch("authen/getPrivacy")
        .then((res) => {
          this.privacyData = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    validationForm() {
      this.$refs.registerForm.validate().then((success) => {
        if (success && this.password == this.confirmpassword) {
          this.isLoading = true;
          this.$refs["my-modal"].show();
        } else {
          this.isError = true;
          this.isErrorMessage = "ยืนยันรหัสผ่านไม่ถูกต้อง";
          this.isLoading = false;
        }
      });
    },
    handleOk(bvModalEvt) {
      if (this.password == this.confirmpassword) {
        const registerModel = {
          // firstName: this.firstName,
          // lastName: this.lastName,
          fullName: this.fullName,
          phone: this.phone,
          email: this.email,
          password: btoa(this.password),
          confirmPassword: btoa(this.confirmpassword),
          userName: "",
          contactType: 1,
        };

        console.log("registerModel", registerModel);
        // console.log('registerModel', JSON.stringify(registerModel))

        store
          .dispatch("authen/register", registerModel)
          .then((res) => {
            if (res.data.success) {
              console.log("response register", res);

              const userModel = {
                name: this.email,
                password: btoa(this.password),
                rememberMe: true,
              };

              console.log("userModel", userModel);

              store
                .dispatch("authen/login", userModel)
                .then((response) => {
                  if (response.data.success) {
                    this.isLoading = false;
                    console.log("response22", response);

                    const userData = {
                      shopId: response.data.data.shopId,
                      shopName: response.data.data.shopName,
                      username: response.data.data.name,
                      fullName: response.data.data.name,
                      phone: response.data.data.phone,
                      email: response.data.data.email,
                      contactId: response.data.data.contactId,
                      contactType: response.data.data.contactType,
                      avatar: response.data.data.avatar,
                      token: response.data.data.token,
                      refreshToken: response.data.data.refreshToken,
                      refreshTokenExpiryTime:
                        response.data.data.refreshTokenExpiryTime,
                      // theme ACL
                      role: "admin",
                      ability: [
                        {
                          action: "manage",
                          subject: "all",
                        },
                      ],
                    };

                    console.log("userData", userData);

                    localStorage.setItem("userData", JSON.stringify(userData));

                    this.$router.push({
                      name: "auth-register-shop",
                      params: { phone: this.phone, email: this.email },
                    });
                  } else {
                    this.isError = true;
                    this.isErrorMessage = response.data.message;
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.isLoading = false;
                });
            } else {
              this.isError = true;
              this.isErrorMessage = res.data.message;
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.isError = true;
        this.isErrorMessage = "ยืนยันรหัสผ่านไม่ถูกต้อง";
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
